module.exports = __webpack_public_path__ + "static/media/BlueEyesIcon.fa45d8a2.svg";